import { createReducer } from 'redux-act';

import { createErrorAction, CreateErrorPayload, resolveErrorAction } from '../actions/error';

const defaultState = { errorMessage: '' };

export type ErrorState = typeof defaultState;

const errorReducer = createReducer<ErrorState>({}, defaultState);

errorReducer.on(createErrorAction, (prevState, { errorMessage }: CreateErrorPayload) => {
  return {
    ...prevState,
    errorMessage,
  };
});

errorReducer.on(resolveErrorAction, (prevState) => ({
  ...prevState,
  errorMessage: '',
}));

export default errorReducer;
